// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__tZL1u","header__brand":"styles_header__brand__FeB0L","navItem":"styles_navItem__pCaQT","navLink":"styles_navLink__tf_FD"};